/* eslint-disable */
// Only need to import these once IE 11 Support!
import 'es6-promise/auto';

const nodelistPolyfill = () => {
  if (window.NodeList && !NodeList.prototype.forEach) {
    const forEach: any = Array.prototype.forEach;
    NodeList.prototype.forEach = forEach;
  }
}

const objectAssignPolyfill = () => {
  if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, 'assign', {
      // @ts-ignore
      value: function assign(target, varArgs) { // .length of function is 2
        'use strict';
        if (target === null || target === undefined) {
          throw new TypeError('Cannot convert undefined or null to object');
        }

        const to = Object(target);

        for (let index = 1; index < arguments.length; index++) {
          const nextSource = arguments[index];

          if (nextSource !== null && nextSource !== undefined) {
            for (const nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }
}

export const initAllPolyfills = () => {
  objectAssignPolyfill();
  nodelistPolyfill();
}

export default initAllPolyfills;